import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useKitchenCapOverrideStore } from "@/store/kitchen-cap-override-store";

/** Renders an AlertDialog when the backend returns
 *  ``409 { code: "kitchen_capacity_override_required" }`` on a reservation
 *  create / update / restore. Reads the ``pending`` slot from the
 *  standalone ``useKitchenCapOverrideStore`` set by ``apiCreateReservation``
 *  and friends, and resolves the awaiting Promise based on the user's
 *  choice. Mounted once in ``__root.tsx``. */
export function KitchenCapacityOverrideDialog() {
  const pending = useKitchenCapOverrideStore((s) => s.pending);
  const close = useKitchenCapOverrideStore((s) => s.close);

  const ctx = pending?.context;
  return (
    <AlertDialog
      open={pending !== null}
      onOpenChange={(open) => {
        if (!open) close(false);
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Cocina al límite</AlertDialogTitle>
          <AlertDialogDescription>
            {ctx ? (
              <>
                La franja <strong>{ctx.slot_local_time}</strong> ya tiene{" "}
                <strong>{ctx.current_pax}</strong> reservas. Si creas esta de{" "}
                <strong>{ctx.requested_pax} pax</strong>, vas a quedar en{" "}
                <strong>{ctx.would_be}</strong> sobre el tope de cocina de{" "}
                <strong>{ctx.cap}</strong>.
                <br />
                <br />
                ¿Confirmar y crear igual?
              </>
            ) : null}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => close(false)}>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={() => close(true)}>Confirmar y crear</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
